export enum RoleTypes {
    Owner = 1,
    Admin,
    Member
}